import { JSX } from 'react';

export enum ESettingsTypes {
  Site = 'site',
  Registration = 'registration',
  Advanced = 'advanced',
  Moderation = 'moderation',
  Add_Ons = 'add_ons',
  Integrations = 'integrations',
  Content_Security = 'content_security',
}

export enum ESettingsTypesLabels {
  Site = 'General',
  Registration = 'Access',
  Advanced = 'Advanced',
  Moderation = 'Moderation',
  Add_Ons = 'Add Ons',
  Integrations = 'Integrations',
  Content_Security = 'Content Security',
}

export enum ESettingsAdvancedWidgetLabels {
  COOKIE_BANNER = 'Cookie Banner',
  EMAIL_OPTIN = 'Marketing Emails Opt-in',
  SESSION_METADATA = 'Session Metadata',
  PUBLISH_LOCKING = 'Publish Locking',
  PRODUCT_ID = 'Product ID (DMA)',
  REDIRECT_URL = 'Redirect URL',
  PAGE_TRANSLATIONS = 'Page Translations',
  IN_PERSON_ATTENDEE_MODE = 'In-Person Attendee Mode',
}

export type TSettingsAdvancedWidget = {
  label: string;
  content?: JSX.Element;
};

export interface ISiteDetailMetadata {
  name: string;
  description: string;
}

export interface ICalendarDetailMetadata {
  name: string;
  description: string;
}
